// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3TS3L","large":"styles_large__1TcqC"};